<template>
  <div>
    <means>
      <div slot="title">比价规避方法</div>
      <strong slot="tips">方法一:直接使用钱收收APP</strong>
      <div slot="imgOne">
        <img src="../../static/instructions/openqss.jpg" alt="" />
      </div>
      <div slot="tipsOne">第一步<br />打开钱收收</div>
      <div slot="imgTwo">
        <img src="../../static/instructions/mean-search.jpeg" alt="" />
      </div>
      <span slot="tipsTwo">第二步<br />搜索你想要的商品</span>
      <div slot="imgThree">
        <img src="../../static/instructions/mean-select.jpeg" alt="" />
      </div>
      <span slot="tipsThree">第三步<br />选中商品，进入详情页</span>
      <div slot="imgFour">
        <img src="../../static/instructions/mean-details.jpeg" alt="" />
      </div>
      <span slot="tipsFour"
        >第四步<br />点击“领券购买”，跳转到<br />拼多多下单</span
      >
    </means>
  </div>
</template>

<script>
import Means from "./means.vue";
export default {
  components: {
    Means
  }
};
</script>

<style lang="less" scoped></style>
